import { render } from "./AboutBeatday.vue?vue&type=template&id=e5b328f2"
import script from "./AboutBeatday.vue?vue&type=script&lang=js"
export * from "./AboutBeatday.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__